import React, {useRef, useState} from "react";
import ReactDOM from 'react-dom';
import * as dayjs from "dayjs";
import * as $ from 'jquery'
import {
  Button,
  Chip,
  CircularProgress,
  FormControlLabel,
  Link,
  makeStyles,
  Radio,
  RadioGroup,
  Typography
} from "@material-ui/core";
import {ReactRender, ReactUnmount} from "@/components/ReactRender";
import {useTranslation} from "@/langs/useTranslation";
import {getAlarmTemplatesApi, getAndroidAppList, setFileConfig} from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import HasPermission from "@/components/commons/HasPermission";
import styles from './index.module.less'
import Loading from "@/containers/Loading";
import {getDownloadLinkAPI} from "@/apis/getDownloadLinkAPI";
import Modal from "@/components/Modal";
import DeleteFileModal from "../Modal/DeleteFIleModal";
const useStyles = makeStyles(theme => ({
  packageImageBox: {
    display: 'flex',
    alignItems: 'center',
    "& .packageImage" :{
      width: 28,
      height: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#00AFC6',
      fontSize: 14,
      fontWeight: 500,
      borderRadius: 5,
      color: '#FFFFFF'
    },
    "& .content-text": {
      marginLeft: 10
    }
  },

}))

/**
 * renderPackageBox 函数用于根据提供的数据行和样式类渲染一个包含包裹图标和名称的盒子。
 * 如果数据行中没有图标或图标长度小于0，则会显示包裹名称的第一个字母，否则将显示图标图片。
 * @param row
 * @param makeStyleClass
 * @returns {JSX.Element}
 */
const renderPackageBox = (data,row, makeStyleClass) => {
  if (!row.icon_link || row.icon_link.length < 0) {
    return (
      <div className={makeStyleClass.packageImageBox}>
        <div className="packageImage">{row.package_name.charAt(0)}</div>
        <div className="content-text">{row.package_name}</div>
      </div>
    );
  }
  return (
    <div className={makeStyleClass.packageImageBox}>
      <div className="packageImage" style={{backgroundColor: "transparent"}}>
        <img src={row.icon_link} style={{ width: '100%', height: '100%', borderRadius: '5px' }} alt={row.package_name} />
      </div>
      <div className="content-text">{row.package_name}</div>
    </div>
  );
};

export const WindowsAppListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      getSearchParams,
      footer,
      children,
      onLoaded,
      handleUpdateApp,
      expandDataRef,
      handleReloadDataTable
    },
    ref
  ) => {
    const {t} = useTranslation();
    const expandData = useRef({})
    const makeStyleClass = useStyles()
    const ajaxData = useRef()
    expandDataRef.current = expandData.current

    const [appUploadConfig, setAppUploadConfig] = useState({
      open: false
    })
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [delFileInfo, setDelFileInfo] = useState({})

    const handleBtnClick = (row, td, callback) => {
      const isExpand = $(td).find('div').html() !== '+'
      // $(td).find('div').html(isExpand ? '+' : '-')
      if (isExpand) collapse(row, td)
      else {
        expand(row, td, callback)
      }
    }

    const columns = [
      {
        name: 'btn',
        data: null,
        searchable: false,
        orderable: false,
        className: 'center',
        width: 10,
        style: {padding: 0},
        createdCell: (td, data, row) => {
          ReactRender(
            <ExpandBtn onClick={callback => handleBtnClick(row, td, callback)} />,
            td
          );
        }
      },
      {
        data: "package_name",
        title: t({defaultMessage: "应用程序名称"}),
        searchable: true,
        render: (data,type,row) => {
          const container = document.createElement('div');
          ReactDOM.render(renderPackageBox(data,row,makeStyleClass), container);
          return container.innerHTML;
        }
      },
      {
        data: "package_id",
        title: t({defaultMessage: "进程名称"}),
        searchable: true
        // orderable: false,
      },
      {
        data: "extension",
        title: t({defaultMessage: "格式"})
      },
      {
        data: "version",
        title: t({defaultMessage: "版本"}),
        searchable: true
      },
      {
        data: "extend",
        title: t({defaultMessage: "部署文件指令"}),
        searchable: true
      },
      // {
      //   data: "version_code",
      //   title: t({defaultMessage: "版本代码"}),
      //   searchable: true
      // },
      {
        data: "size",
        title: t({defaultMessage: "大小"}),
        render: data => {
          return `${(data / 1048576).toFixed(2)} MB`
        }
      },
      {
        data: "creator_name",
        title: t({defaultMessage: "上传者"}),
        searchable: true
      },
      {
        data: "uploaded_at",
        title: t({defaultMessage: "上传时间"}),
        render: data => {
          return dayjs(data).format("YYYY/MM/DD HH:mm:ss");
        }
      },
      // {
      //   data: "updatePerson",
      //   title: t({ defaultMessage: "更新者" })
      // },
      // {
      //   data: "updateTime",
      //   title: t({ defaultMessage: "更新时间" }),
      //   render: data => {
      //     return dayjs(data).format("YYYY/MM/DD HH:mm:ss");
      //   }
      // },
      {
        data: null,
        title: t({defaultMessage: "操作"}),
        className: "center nowrap",
        searchable: false,
        orderable: false,
        width: 120,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              <HasPermission permission="android_app_management_download_file">
                <Button size="small" color="primary" onClick={() => getDownloadLinkAPI(row.id)}>
                  {t({defaultMessage: "下载"})}
                </Button>
              </HasPermission>
              <HasPermission permission="android_app_management_add_update_file">
                <Button size="small" color="primary" onClick={() => handleUpdateApp(row)}>
                  {t({defaultMessage: "更新"})}
                </Button>
              </HasPermission>
              <Button size="small" color="secondary" onClick={() => {
                setDeleteModalOpen(true)
                setDelFileInfo({id: data.id, name: data.name, uploaded_at: data.uploaded_at})
              }}>
                {t({defaultMessage: "删除"})}
              </Button>
            </>,
            td
          );
        }
      }
    ];

    const expand = (row, td, callback) => {
      getAndroidAppList({
        ...ajaxData.current,
        // ...getSearchParams(),
        page: 1,
        pageSize: 999,
        start: 0,
        length: 999,
        target: 'windows',
        parent_id: row.id,
        order: [{column: 5, dir: 'asc'}]
      }).then(res => {
        if (callback) callback()
        const oldVersions = res.data
        const $tr = $(td).parent()
        const newTrs = []
        for (let i = 0; i < oldVersions.length; i++) {
          const newTr = $('<tr></tr>')
          $tr.after(newTr)
          newTrs.push(newTr[0])
        }
        expandData.current[row.package_id] = newTrs
        newTrs.forEach((tr, index) => {
          const oldData = oldVersions[index]
          ReactRender(
            <>
              {columns.map((column,index) => {
                if (column.name === 'btn') return <td key={index}/>
                if (column.data === null) return (
                  <td className="sticky right operation" key={index}>
                    <HasPermission permission="android_app_management_download_file">
                      <Button size="small" color="primary" onClick={() => getDownloadLinkAPI(oldData.id)}>
                        {t({defaultMessage: "下载"})}
                      </Button>
                    </HasPermission>
                    <Button size="small" color="secondary" onClick={() => {
                      setDeleteModalOpen(true)
                      setDelFileInfo({id: oldData.id, name: oldData.name, uploaded_at: oldData.uploaded_at})
                    }}>
                      {t({defaultMessage: "删除"})}
                    </Button>
                  </td>
                )
                const data = oldData[column.data]
                if(column.data === 'package_name'){
                  return (<td style={{paddingLeft: 47}}>{data}</td>)
                }

                return (
                  <td className={column.className} key={index}>
                    {column.render ? column.render(data) : data}
                  </td>
                )
              })}
            </>
            , tr
          )
        })
      })
      // const a = $tr.insertAfter('tr')
    }

    const collapse = (row) => {
      const newTrs = expandData.current[row.package_id]
      if (newTrs) {
        newTrs.forEach(tr => {
          ReactUnmount(tr)
          $(tr).remove()
        })
      }
    }

    const ajax = (data, callback) => {
      ajaxData.current = data
      return getAndroidAppList({
        ...data,
        ...getSearchParams(),
        target: 'windows',
        parent_id: "",
      }).then(res => {
        // res.data = [
        //   {
        //     name: 'Nubis',
        //     packageId: 'EX File Explorer - 1.9.1',
        //     type: 'apk',
        //     version: 'V 1.4',
        //     size: '236MB',
        //     uploadPerson: 'Joan',
        //     uploadTime: Date.now(),
        //     updatePerson: 'Joan',
        //     updateTime: Date.now()
        //   },
        //   {
        //     name: '连连看',
        //     packageId: 'llk - 1.0.0',
        //     type: 'apk',
        //     version: '1,0,0',
        //     size: '36MB',
        //     uploadPerson: 'Joan',
        //     uploadTime: Date.now(),
        //     updatePerson: 'Joan',
        //     updateTime: Date.now()
        //   },
        // ]
        callback({
          data: res.data,
          draw: data.draw,
          recordsFiltered: res.recordsTotal,
          recordsTotal: res.recordsTotal
        });
      });
    };

    const handleConfigConfirm = async () => {
      await setFileConfig({package_id: appUploadConfig.package_id, verify_version: Number(appUploadConfig.verify_version) })
      setAppUploadConfig({open: false})
      handleReloadDataTable()
    }

    const handleEditConfig = row => {
      setAppUploadConfig({
        open: true,
        package_id: row.package_id,
        verify_version: `${row.verify_version}`
      })
    }

    return (
      <>
        <DataTable
          ref={ref}
          ordering
          defaultOrder={[8, "desc"]}
          columns={columns}
          ajax={ajax}
          className={className}
          style={style}
          footer={footer}
          scrollable
          showCheckAll={false}
          onLoaded={onLoaded}
        >
          {children}
        </DataTable>
        <Modal
          title={t({defaultMessage: "上传设置"})}
          open={appUploadConfig.open}
          onClose={() => setAppUploadConfig({open: false})}
          onConfirm={handleConfigConfirm}
        >
          <Typography style={{marginBottom: 16}} variant="body1">
            {t({defaultMessage: "是否校验版本代码"})}
          </Typography>
          <RadioGroup
            aria-label="date"
            name="releaseNow"
            value={appUploadConfig.verify_version}
            onChange={e => setAppUploadConfig(v => {
              if (!e.target) return v
              const newValue = {...v}
              newValue.verify_version = e.target.value
              return newValue
            })}
            row
          >
            <FormControlLabel value="1" control={<Radio color="primary" />} label={t({defaultMessage: "是"})} />
            <FormControlLabel value="0" control={<Radio color="primary" />} label={t({defaultMessage: "否"})} />
          </RadioGroup>
        </Modal>
        <DeleteFileModal
          open={deleteModalOpen}
          onOk={() => {
            setDeleteModalOpen(false)
            ref.current.reload()
          }}
          onClose={() => setDeleteModalOpen(false)}
          fileInfo={delFileInfo}
          tip={t({defaultMessage: "请问您确认要移除此Windows应用程序吗？"})}
        />
      </>
    );
  }
);

const ExpandBtn = ({onClick}) => {
  const [loading, setLoading] = useState(false)
  const [text, setText] = useState('+')
  const handleBtnClick = () => {
    if (text === '+') setLoading(true)
    else setText('+')
    onClick(() => {
      setLoading(false)
      setText('-')
    })
  }
  if (loading) return <CircularProgress size={16} style={{marginTop: 6}} />
  return (
    <div onClick={handleBtnClick} className={styles.expandBtn} data-expand={text==='+'}>
      {text}
    </div>
  )
}
